import React from 'react';
export default (function (props) {
  var color = props.color,
      size = props.size,
      className = props.className,
      style = props.style;
  color = color ? color : 'currentColor';
  size = size ? size : '100%';
  return /*#__PURE__*/React.createElement("svg", {
    style: style,
    className: className,
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 14 16",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: "1",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Account-Adminstration_Menu",
    transform: "translate(-49.000000, -309.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu",
    transform: "translate(0.000000, 56.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(0.000000, 161.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "subscription",
    transform: "translate(0.000000, 80.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_Subscriptions",
    transform: "translate(48.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: "0",
    y: "0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,5 C13.6568542,5 15,6.34314575 15,8 C15,8.88854726 14.6137081,9.68687122 13.9999017,10.2361945 L13.9999998,16 L11.9999998,14 L9.99999977,16 L9.99911749,10.2353163 C9.3858804,9.68602056 9,8.88807388 9,8 C9,6.34314575 10.3431457,5 12,5 Z M11,-1.19904087e-13 C11.5522848,-1.19904087e-13 12,0.44771525 12,1 L12.001004,4.00000049 L11.998996,4 C9.79005861,4 7.99936107,5.790861 7.99936107,8 C7.99936107,9.01441552 8.37694015,9.94063467 8.99921283,10.6457598 L8.999,13 L2,13 C1.44771525,13 1,12.5522847 1,12 L1,1 C1,0.44771525 1.44771525,-1.19904087e-13 2,-1.19904087e-13 L11,-1.19904087e-13 Z M5.99999974,9 L2.99999974,9 L2.99999974,10 L5.99999974,10 L5.99999974,9 Z M6.99999974,6 L2.99999974,6 L2.99999974,7 L6.99999974,7 L6.99999974,6 Z M8.99999975,3 L2.99999975,3 L2.99999975,4 L8.99999975,4 L8.99999975,3 Z",
    id: "icon_subscriptions",
    fillRule: "nonzero"
  }))))))));
});